import { render, staticRenderFns } from "./course-escort.vue?vue&type=template&id=04a6307b&scoped=true&"
import script from "./course-escort.vue?vue&type=script&lang=js&"
export * from "./course-escort.vue?vue&type=script&lang=js&"
import style0 from "./course-escort.vue?vue&type=style&index=0&id=04a6307b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04a6307b",
  null
  
)

export default component.exports